import { Outlet } from 'react-router-dom';

import { ROUTE_KEYS } from '@/navigation/constants';
import { GuardedPageRedirect } from '@/navigation/GuardedPageRedirect';

export function HouseholdFormRoutes() {
  return (
    <GuardedPageRedirect route={ROUTE_KEYS.HOUSEHOLD_FORM_SUBMISSIONS}>
      <Outlet />
    </GuardedPageRedirect>
  );
}
